import {
  HELLO_ERR,
  HELLO_REQ,
  HELLO_RES,
  LOGOUT,
  POST_LOGIN_ERR,
  POST_LOGIN_REQ,
  POST_LOGIN_RES,
  POST_REGISTER_ERR,
  POST_REGISTER_REQ,
  POST_REGISTER_RES,
} from '@/shared/actionTypes';

const INITIAL_STATE = {
  loading: false,
  code: undefined,
  email: undefined,
  auth_token: undefined,
  user_sso_id: undefined,
};

export const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HELLO_REQ:
      return {
        ...state,
        loading: true,
        email: action.payload.email,
      };
    case HELLO_RES:
      return {
        ...state,
        loading: false,
        code: action.payload.code,
      };
    case HELLO_ERR:
      return {
        ...state,
        loading: false,
        code: undefined,
      };

    case POST_LOGIN_REQ:
      return {
        ...state,
        loading: true,
      };
    case POST_LOGIN_RES:
      return {
        ...state,
        loading: false,
        auth_token: action.payload.auth_token,
        user_sso_id: action.payload.user_sso_id,
      };
    case POST_LOGIN_ERR:
      return {
        ...state,
        loading: false,
        auth_token: undefined,
        user_sso_id: undefined,
      };
    case POST_REGISTER_REQ:
      return {
        ...state,
        loading: true,
      };
    case POST_REGISTER_RES:
      return {
        ...state,
        loading: false,
        code: action.payload.code,
      };
    case POST_REGISTER_ERR:
      return {
        ...state,
        loading: false,
        code: undefined,
      };

    case LOGOUT:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
